import React from 'react';

const WhyChooseUs: React.FC = () => {
    return (
        <div className="why-choose-us">
            <h1>🛡️ Why Choose Us</h1>
            <p>At Uma Shankar Security agency, we believe that true security and dependable manpower begin with trust, training, and professionalism. We don't just provide personnel — we deliver peace of mind.</p>
            
            <div className="reasons">
                <div className="reason">
                    <h3>✅ 1. Skilled & Verified Workforce</h3>
                    <p>All our guards and manpower staff are background-verified, medically fit, and trained as per industry and government standards to ensure discipline, vigilance, and reliability in every task they perform.</p>
                </div>

                <div className="reason">
                    <h3>⚙️ 2. Customized Solutions</h3>
                    <p>Whether you need industrial, commercial, or residential security, or temporary and permanent manpower, we design and deliver customized service plans that match your operational requirements and business priorities.</p>
                </div>

                <div className="reason">
                    <h3>🕒 3. 24/7 Operational Support</h3>
                    <p>Our control rooms and field supervisors operate round-the-clock to provide continuous monitoring and on-site assistance — ensuring prompt response, coordination, and uninterrupted protection for your premises.</p>
                </div>

                <div className="reason">
                    <h3>💼 4. Experience & Professionalism</h3>
                    <p>With years of proven experience serving corporate offices, factories, residential communities, institutions, and events, we understand the importance of professional conduct and consistent quality in every deployment.</p>
                </div>

                <div className="reason">
                    <h3>🔒 5. Compliance & Accountability</h3>
                    <p>We strictly comply with labour laws, PF, ESI, and all statutory regulations. Every contract is supported with transparent documentation and regular reporting, ensuring full legal compliance and ethical integrity.</p>
                </div>
            </div>

            <p className="closing">✨ Choose Uma Shankar Security Agency — where reliability meets responsibility, and security becomes a partnership you can trust.</p>
        </div>
    );
};

export default WhyChooseUs;